import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { State } from './state';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { IColumnModel, ColumnModel } from 'table-editor';
import { WriteOrdinalSuffixOfNumber } from 'starbase-launcher';

export class Regiment extends StarbaseEntity implements Serializable<Regiment> {
  public regimentNo: number;
  public regimentDisplay: string;
  public regimentNumberDisplay: string;

  constructor() {
    super();
  }

  public static RegimentColumnData(editable: boolean = false): IColumnModel[] {
    return [
      new ColumnModel('UID', 'uid', 'UID', false, 'number', false, true, 10, false),
      new ColumnModel('Regiment #', 'regimentNo', 'RegimentNo', editable, 'number', true, true, 200, false),
      new ColumnModel('Created By', 'createdByUser', 'CreatedByUser', false, 'string', false, true, 100, false),
      new ColumnModel('Created Date/Time', 'createdDateTime', 'CreatedDateTime', false, 'date', false, true, 50, false)
    ];
  }
  public static CreateRegimentColumnData(states: State[]): IColumnModel[] {
    return [
      new ColumnModel('Regiment #', 'regimentNo', 'RegimentNo', true, 'number', true, true, 200, false),
      new ColumnModel('State', 'state', 'State', true, 'dropdown', false, true, 10, false, states, 'state_Name')
    ];
  }

  public static setupCollection(collection: Regiment[]): void {
    of(collection).pipe(
      map((regs: Regiment[]) =>
        regs.map((r: Regiment) => {
          r = new Regiment().deserialize(r);
          // r.state = new State().deserialize(r.state);
        })
      )
    ).subscribe();
  }

  deserialize(input) {
    const r = Object.assign(new Regiment(), input);
    r.regimentNumberDisplay = this.regimentDisplayText();
    return r;
  }

  public regimentDisplayText(): string {
    return WriteOrdinalSuffixOfNumber(this.regimentNo);
  }
  // public concatenateRegimentDisplay(): string {
  //     return WriteOrdinalSuffixOfNumber(this.regimentNo) + ' ' + this.state_Name;
  // }
}
